import React from "react";

import Nav from "../../layout/Nav";
import Body from "../../layout/Body";
import Footer from "../../layout/Footer";

import Faqs from "../../modules/faqs";

const FaqPage = (props) => {
  return (
    <>
      <Nav />
      <Body>
        <Faqs />
      </Body>
      <Footer />
    </>
  );
};

export default FaqPage;
